import {CodeName} from './code-name';
import {GUID} from "../../shared/models/GUID-interface";

export class AdditionalFilterData {
    constructor(
        public readonly name: string, public filterData: CodeName[], public allItemsQuantity: number
    ) {

    }
}

export class AdditionalFilterDataGUID implements GUID{
    constructor(public readonly GUID: string, public additionalFilterData: AdditionalFilterData[]) {

    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/additional-filter-data.ts